import React, { useState } from 'react';
import MetaTags from 'react-meta-tags';
import { Button, Card, CardBody, CardHeader, Col, Container, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import ApiClient from '../BaseUrl/ApiClient';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function UserSubscription() {
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [subscriptionStatus, setSubscriptionStatus] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email) {
            toast.error('Please enter an email address');
            return;
        }

        setIsLoading(true);
        try {
            const response = await ApiClient.post(
                `/admin/subscription/user/${email}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`
                    }
                }
            );

            if (response.data.responseCode === 200) {
                toast.success('User subscribed successfully!');
                setSubscriptionStatus('subscribed');
            } else {
                toast.error(response.data.responseMessage?.join(', ') || 'Failed to subscribe user');
            }
        } catch (error) {
            console.error('Error:', error);
            if (error.response) {
                toast.error(error.response.data.responseMessage?.join(', ') || 'Subscription failed');

                
            } else {
                toast.error('Network error. Please try again.');
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <React.Fragment>
            <ToastContainer />
            <div className="page-content">
                <MetaTags>
                    <title>Subscribe User </title>
                </MetaTags>
                <Container fluid>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardHeader>
                                    <h3 >Subscribe User</h3>
                                </CardHeader>
                                
                                <CardBody>

                                    <Form onSubmit={handleSubmit}>
                                        <FormGroup>
  <Row className="align-items-end">

    <Col lg="9" xs="12" md="7">
      <Label for="email">Email</Label>
      <Input
        type="email"
        name="email"
        id="email"
        placeholder="Enter user email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />
    </Col>


    <Col lg="3" xs="12" md="5" className="mt-3 mt-md-0">
      <Button
        color="primary"
        type="submit"
        disabled={isLoading}
        className="w-100"
      >
        {isLoading ? 'Subscribing...' : 'Subscribe User'}
      </Button>
    </Col>
  </Row>
</FormGroup>

                                    </Form>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
}

export default UserSubscription;